<template>
  <div class="has_market_price">
    <Header />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h5 class="w-50 py-3 my-2 font-weight-bold">
            Welcome to our Blog -
            <small
              >Enjoy stories about our impact, our work, our communities and the
              humans of Quick Leap.</small
            >
          </h5>
        </div>
        <div class="col-md-6 col-lg-5 text-center">
          <div class="img-section mb-4">
            <a href="javascript:void(0)" class="d-block">
              <img
                src="/assets/images/blog/impact.jpg"
                height="400px"
                class="img-fluid mb-1"
              />
              <strong>Our Impact story - First 6 months</strong>
            </a>
          </div>
          <div class="img-section mb-4">
            <a href="javascript:void(0)" class="d-block">
              <img
                src="/assets/images/blog/alliance.jpg"
                height="400px"
                class="img-fluid mb-1"
              />
              <strong> Planning and sourcing strategic alliances </strong>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-lg-7 text-center">
          <div class="row">
            <div class="col-md-6">
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/blog/1.jpg"
                    alt=""
                    class="img-fluid mb-1"
                  />
                  <strong
                    >Tracking the Supply chain from farm to markets.</strong
                  >
                </a>
              </div>
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/blog/2.jpg"
                    alt=""
                    class="img-fluid mb-1"
                  />
                  <strong>Food Journeys.</strong>
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/blog/3.jpg"
                    alt=""
                    class="img-fluid mb-1"
                  />
                  <strong>iSponsor Trade.</strong>
                </a>
              </div>
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/blog/4.jpg"
                    alt=""
                    class="img-fluid mb-1"
                  />
                  <strong>How Quick Leap can help your food business.</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <market-price />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
// import Footer from "@/components/Footer.vue";
import MarketPrice from "@/components/MarketPrice.vue";
export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Blog",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Header, MarketPrice }
};
</script>
